<template>
    <div>
        <template v-for="(errors, type) in $page.props.errors" :key="type">
            <div v-for="(message, index) in errors" :key="`${type}-${index}`" class="alert alert-danger rounded-0" role="alert">
                {{ message }}
                <button type="button" class="close" :aria-label="trans('generic.close')" @click="dismissError(type, index)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    methods: {
        dismissError(type, index) {
            this.$delete(this.$page.props.errors[type], index)
            if (Object.keys(this.$page.props.errors[type]).length === 0) {
                this.$delete(this.$page.props.errors, type)
            }
        },
    },
}
</script>
